import PropTypes from 'prop-types'

const IsAction = ({ isAction, data, actionCell, normalCell }) => {
	return isAction ? actionCell({ ...data }) : normalCell({ ...data })
}

IsAction.propTypes = {
	isAction: PropTypes.bool.isRequired,
}

IsAction.defaultPropTypes = {}

export default IsAction
